<template>
  <el-card class="box-card mb-50" id="changeFirstLogin">
    <el-row>
      <el-col :span="24">
        <div class="header-first-login">
          <span>初回ログインのためのログインパスワードの初回登録が必要です。</span><br>
          <span>任意のパスワードを入力し、ログインパスワードの初回登録を行なってください。</span>
        </div>
        <el-form :rules="rules" :model="inputForm" ref="inputForm" id="form" :action="urls.first_login" method="post">
          <div class="group-input"><span>{{ $t('change_password.group_first_login_input') }}</span></div>
          <el-form-item prop="password" :error="getErrorForField('password', errors)">
            <label slot="label" class="el-form-item__label">{{ $t('change_password.label.new_password') }}</label>
            <div class="text-danger" v-if="role === false"><span>{{ $t('change_password.check_password') }}</span></div>
            <el-input :placeholder="$t('password')" v-model="inputForm.password" name="password" :type="typeInput"/>
          </el-form-item>
          <el-form-item prop="passwordConfirm" class="mt-10">
            <el-input :placeholder="$t('password_confirm')" v-model="inputForm.passwordConfirm" :type="typeInput"/>
          </el-form-item>
          <el-checkbox v-model="isShowPassword" :label="$t('show_password')" size="small" @change="showPassword" class="mt-20"/>
          <input type="hidden" name="_token" :value="csrf">
          <div class="form-footer">
            <el-button class="btn-reset" @click="reset('inputForm')">{{ $t('btn_set_password') }}</el-button>
          </div>
        </el-form>
       </el-col>
    </el-row>
  </el-card>
</template>
<script>
  export default {
    props: {
      errors: { type: Object, required: false },
      urls: { type: Object, required: true, default: {} },
      role: { type: Boolean, required: true, default: true },
    },
    data() {
      const checkPasswordConfirm = (rule, value, callback) => {
        if (value !== this.inputForm.password) {
          callback(new Error(this.$t('errors.password.confirm')));
        } else {
          callback();
        }
      };
      const checkRegexPassword = (rule, value, callback) => {
        const regex = new RegExp(/^(?=.*[0-9])(?=.*[A-Z|a-z])(?=.*[\!\@\#\$\%\^\&\*\(\){\}[\]:\;\<\>\,\.\?\/~\_\+\-\=\\])[a-zA-Z0-9\!\@\#\$\%\^\&\*\(\){\}[\]:\;\<\>\,\.\?\/~\_\+\-\=\\]{8,255}$/);
        if (!regex.test(value)) {
          callback(new Error(this.$t('errors.password.format')));
        } else {
          callback();
        }
      }
      return {
        inputForm: {
          password: "",
          passwordConfirm: ""
        },
        rules: {
          password: [
            { required: true, message: this.$t('errors.change_password.required', [this.$t('new_password')]), trigger: 'blur' },
            { min: 8, message: this.$t('errors.change_password.min', [this.$t('new_password'), 8]), trigger: 'blur' },
            { max: 255, message: this.$t('errors.change_password.max', [this.$t('new_password'), 255]), trigger: 'blur' },
            { validator: checkRegexPassword, trigger: 'blur', message: this.$t('errors.change_password.format', [this.$t('new_password')]) },
          ],
          passwordConfirm: [
            { required: true, message: this.$t('errors.change_password.confrim_password_required'), trigger: 'blur' },
            { validator: checkPasswordConfirm, trigger: 'blur', message: this.$t('errors.change_password.confrim_password_diffirent')},
          ]
        },
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        isShowPassword: false,
        typeInput: 'password'
      }
    },
    methods: {
      reset(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const form = document.getElementById("form");
            form.submit();
          } else {
            return false;
          }
        });
      },

      isErrorForField(field, errors) {
        return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
      },

      getErrorForField(field, errors) {
        return this.isErrorForField(field, errors) ? errors[field][0] : '';
      },

      showPassword() {
        this.$refs.inputForm.clearValidate();
        this.typeInput = this.isShowPassword ? 'text' : 'password';
      }
    },
  }
</script>

<style lang="scss">
  #changeFirstLogin {
    .header-first-login {
      font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
    }
    .el-form {
      width: 100%;
      .el-input {
        width: 400px;
      }
      .el-form-item__content {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }
      .el-form-item__label {
        width: 100%;
        text-align: left;
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #000000;
        justify-content: flex-start;
        font-weight: 700;
      }
      .text-danger {
        white-space: pre-line;
        color: #AC3B29;
        font-size: 13px;
        letter-spacing: 1.3px;
        line-height: 21px;
        margin-bottom: 8px;
      }
    }
  }
</style>
